import React from 'react';
import { Root } from './styled.js';

const Header = ({ children }) => {
    return React.createElement(Root, { className: 'tend-ui-drawer-header' }, children);
};
Header.displayName = 'Drawer.Header';

export { Header };
